<template lang="pug">
.homer
    AppIcon(name="logoHomer")
    p.u-mt-xs(v-html="$t('mantra')")
    .u-mt-xs
      AppLink(to="/homer" class="button-link is-medium" :title="$t('subscribe')") {{$t('subscribe')}}

</template>

<style lang="stylus">
.homer
  .icon-logoHomer
    width: unitRes(250, 400)
    height: unitRes(70, 113)

  p
    font-size: unitRes(24, 40)
</style>

<script>
export default {
  name: 'Homer'
};
</script>

<i18n>
{
  "en": {
    "mantra":"Subscribe to Homer newsletter for <br> weekly updates.",
    "subscribe":"Subscribe!"
  },
  "ar": {
    "mantra":"اشترك في النشرة الإخبارية لهومر لتصلك <br>  التحديثات الاسبوعية.",
    "subscribe":"اشترك!"
  }
}
</i18n>
